module.exports = __webpack_public_path__ + "static/media/gri.71ed23f9.svg";